import classNames from "classnames";
import { Link } from "gatsby";
import PropTypes from "prop-types";

const MenuLeftItem = ({ title = "", href = "", icon, isActive = false }) => {
  const url = `/${href}`;
  return (
    <Link
      to={url}
      className={classNames("side-bar-item", {
        selected: isActive,
      })}
    >
      <div className="side-bar-item__icon">{icon}</div>
      {!!title && <div className="side-bar-item__title">{title}</div>}
    </Link>
  );
};

MenuLeftItem.propTypes = {
  title: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.node,
  isActive: PropTypes.bool,
};

export default MenuLeftItem;
